module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/utensils.svg?6b1ab0955b37bfdd34749ae738617374";